var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "History-Spartan-Helmet--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "History Spartan Helmet Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.52 14.35a7.5 7.5 0 0 0 -15 0v4.5a1 1 0 0 0 2 0v-2.5A2.5 2.5 0 0 1 9 13.85h3.5a1 1 0 0 1 0 2 4 4 0 0 0 -4 4v3.3a0.49 0.49 0 0 0 0.21 0.41 0.51 0.51 0 0 0 0.45 0.06L19.59 20a1.58 1.58 0 0 0 0.94 -0.92 1.55 1.55 0 0 0 -0.11 -1.31 6.5 6.5 0 0 1 -0.9 -3.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06 6.84a0.51 0.51 0 0 0 0.16 -0.67L5.06 2.43a0.51 0.51 0 0 0 -0.32 -0.24 0.5 0.5 0 0 0 -0.39 0.07A12.19 12.19 0 0 0 0.07 7.13a0.5 0.5 0 0 0 0.19 0.65l3.4 2a0.49 0.49 0 0 0 0.68 -0.16 9 9 0 0 1 2.72 -2.78Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44 5.47a9 9 0 0 1 2.61 0.83 0.49 0.49 0 0 0 0.65 -0.2l1.66 -2.87a0.51 0.51 0 0 0 -0.15 -0.66A12.37 12.37 0 0 0 13.62 0.62a0.5 0.5 0 0 0 -0.42 0.11 0.46 0.46 0 0 0 -0.18 0.38V5a0.51 0.51 0 0 0 0.42 0.47Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13 5.76a0.51 0.51 0 0 0 0.62 0.24 9.34 9.34 0 0 1 2.79 -0.61 0.5 0.5 0 0 0 0.48 -0.5v-4a0.5 0.5 0 0 0 -0.48 -0.5L11 0.35a12.7 12.7 0 0 0 -4.82 0.93 0.54 0.54 0 0 0 -0.28 0.31A0.54 0.54 0 0 0 6 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.24 9.43a0.54 0.54 0 0 0 -0.3 -0.31 0.5 0.5 0 0 0 -0.43 0l-2 1.13a0.49 0.49 0 0 0 -0.21 0.62 9.26 9.26 0 0 1 0.64 2.6 1.5 1.5 0 0 0 1.49 1.34A1.51 1.51 0 0 0 24 13.24a15.6 15.6 0 0 0 -0.76 -3.81Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65 7.32a8.83 8.83 0 0 1 1.79 1.92 0.49 0.49 0 0 0 0.66 0.15l2.15 -1.24a0.49 0.49 0 0 0 0.2 -0.65 13.25 13.25 0 0 0 -2.61 -3.59 0.46 0.46 0 0 0 -0.42 -0.13 0.5 0.5 0 0 0 -0.36 0.24l-1.53 2.66a0.49 0.49 0 0 0 0.12 0.64Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export default ForwardRef;